import { render } from "./TournamentScheduleList.vue?vue&type=template&id=60ba96c3&scoped=true"
import script from "./TournamentScheduleList.vue?vue&type=script&lang=js"
export * from "./TournamentScheduleList.vue?vue&type=script&lang=js"

import "./TournamentScheduleList.vue?vue&type=style&index=0&id=60ba96c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ba96c3"]])

export default __exports__